import { render, staticRenderFns } from "./to.vue?vue&type=template&id=6e23201c&scoped=true"
import script from "./to.vue?vue&type=script&lang=ts"
export * from "./to.vue?vue&type=script&lang=ts"
import style0 from "./to.vue?vue&type=style&index=0&id=6e23201c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e23201c",
  null
  
)

export default component.exports